
export const ORG_DIVISION_LIST_ROUTE = '/dashboard/org-division-list';
export const ORG_DIVISION_LIST_NAV_KEY = 'dashboard/org-division-list';

export const ORG_DIVISION_LIST_QUERY = {
  LEVEL_COUNT: 'level_count',
  NAME: 'name',
  GEO_ITEMS: 'geo_items',
};

export const ORG_DIVISION_GEO_ITEMS = {
  ALL: 'ALL',
  MAPPED: 'MAPPED',
  UNMAPPED: 'UNMAPPED',
};

export const ORG_DIVISION_GEO_ITEMS_OPTIONS = [
  { value: ORG_DIVISION_GEO_ITEMS.ALL, label: 'All' },
  { value: ORG_DIVISION_GEO_ITEMS.MAPPED, label: 'Mapped' },
  { value: ORG_DIVISION_GEO_ITEMS.UNMAPPED, label: 'Unmapped' },
];

export const ORG_DIVISION_ROOT_DEPTH = 0;
export const ORG_DIVISION_LEVEL_COUNT_MIN = 1;
